import { PermissionCodes } from "@/constants/permissionCodes";
import useAppStore from "@/context/store";
import { getDeliveryDetail } from "@/services/qingzhou";
import { isPersonalOrg } from "@/utils/gaodingVip";
import { OrgService } from "@/utils/gd-org";
import classNames from "classnames";
import { useEffect, useState } from "react";
import GdPermission from "../GdPermission";
import styles from "./SideNavBanner.module.less";

export default function SideNavBanner({ isCollapsed }) {
  const user = useAppStore((state) => state.user);
  const orgInfo = useAppStore((state) => state.orgInfo);
  const orgService = OrgService.getInstance();
  const [bannerConfig, setBannerConfig] = useState(null);

  useEffect(() => {
    const fetchBannerConfig = async () => {
      const result = await getDeliveryDetail(
        "framework--side-nav_activity-banner"
      );
      const material = result?.pit_modules?.[0]?.material;
      if (!material) return;

      const bannerConfig = {
        id: result?.pit_modules?.[0].module_id, // 投放物料的id，用于资源位上报
        ...(material.activity_banner || {}),
      };

      if (bannerConfig) {
        setBannerConfig(bannerConfig);
      }
    };

    if (user && orgInfo) {
      fetchBannerConfig();
    }
  }, [user, orgInfo]);

  if (!user || !isPersonalOrg(orgInfo?.org) || !bannerConfig) {
    return null;
  }

  return (
    <GdPermission code={PermissionCodes.upgrateEnterpriseMenu}>
      <div
        className={classNames(styles.bannerContainer, {
          [styles.collapsed]: isCollapsed,
        })}
        onClick={() => orgService.upgradeOrg()}
        data-tooltip={isCollapsed ? bannerConfig.title : undefined}
        data-tooltip-position="right"
        data-gd-expose="resource_loc_expose"
        data-gd-click="resource_loc_click"
        data-module-name="左侧导航栏"
        data-subject-name="资源位"
        data-apply-client="使用端"
        data-resource-id={bannerConfig?.id}
        data-resource-title={bannerConfig.title}
        data-resource-location={0}
      >
        {isCollapsed ? (
          <img
            key="img-collapsed"
            className={styles.bannerImage}
            src={bannerConfig.img_small}
            alt={bannerConfig.title}
          />
        ) : (
          <img
            key="img-normal"
            className={styles.bannerImage}
            src={bannerConfig.img}
            alt={bannerConfig.title}
          />
        )}
      </div>
    </GdPermission>
  );
}
